module.exports = __webpack_public_path__ + "pigmentace_3_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/pigmentace_3_before_tn.jpg
// module id = 1442
// module chunks = 0